import { identity, isFunction } from 'lodash/fp';
import { reduxForm } from 'redux-form';
import { v4 as uuidv4 } from 'uuid';
import { saveData } from 'actions';

const dataCreationForm = ({ type, onSubmitData = identity, ...options }) => {
    const onSubmit = (values, dispatch, props) => {
        // Le type peut être une fonction qui détermine le type en fonction des valeurs du formulaire
        const resolvedType = isFunction(type) ? type(values, props) : type;

        return dispatch(saveData(resolvedType, uuidv4(), onSubmitData(values, props)));
    };

    return reduxForm({
        onSubmit,
        ...options,
    });
};

export default dataCreationForm;
